import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  return (
    <>
      <Helmet><title>Drs.Farm | 404</title></Helmet>
      <section className="panel">
        <h1>404</h1>
        <p>ページが見つかりません。</p>
        <Link to="/" className="btn">トップへ戻る</Link>
      </section>
    </>
  );
}
